import {
  STORE_STATUS_ERROR,
  STORE_STATUS_FINISHED,
  STORE_STATUS_LOADING,
} from 'constants/store'
import { GenericState, GetRejectValue } from './create-slice'
import { ActionReducerMapBuilder, AsyncThunk } from '@reduxjs/toolkit'
import { Payload } from 'stores'

export type ExtraReducers = (
  builder: ActionReducerMapBuilder<GenericState<any>>
) => void

export const createReducers =
  <State, Service, TPayload extends Payload>(
    thunkAction: AsyncThunk<State, Promise<Service>, TPayload>,
    initialState: State
  ): ExtraReducers =>
  (builder: ActionReducerMapBuilder<GenericState<any>>) => {
    builder.addCase(thunkAction.pending, (state: GenericState<State>) => {
      state.status = STORE_STATUS_LOADING
    })
    builder.addCase(
      thunkAction.fulfilled,
      (state: GenericState<State>, { payload }) => {
        state.error = null
        state.status = STORE_STATUS_FINISHED
        state.data = payload
      }
    )
    builder.addCase(
      thunkAction.rejected,
      (state: GenericState<State>, { payload }) => {
        const { code, message, details } = (payload || {}) as GetRejectValue
        state.data = initialState
        state.status = STORE_STATUS_ERROR
        state.error = {
          name: code,
          message: message,
          details: details,
        }
      }
    )
  }
